import http from "../services/httpService";

const apiUrl = http.getApiUrl();
const endPoint = "/dataUsage/";
const url = apiUrl + endPoint;

export async function getMyDataUsage() {
  //return await http.get(url + "getDataUsage");
  return {};
}
